/**
 * How numbers are written for a person: one place, as on the server
 * (app/core/words.py). The same size read « 2.55 Go » on a card and
 * « 6,46 Go » on the next one (audit 03/10).
 */
export function formatGb(value: number, digits = 1): string {
	return `${value.toLocaleString("fr-FR", { maximumFractionDigits: digits })} Go`;
}
